"use strict";

        var svgToInline = {
    loaded: [],

    load: function(object) {
        this.imgUrl = '';
        this.svg = '';

        if (!object.classList.contains("svg-inited")) {
            this.load(object);
        }
    },

    request: function(url, callback) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function() { 
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
                callback(xmlHttp.responseText);
        }
        xmlHttp.open("GET", url, true);
        xmlHttp.send(null);
    },

    setUrl: function(){

                if (String(this.object.tagName).toLowerCase() == "img") {
            this.imgUrl = this.object.src;
        }
        else {
            var styles = getComputedStyle(this.object);
            this.imgUrl = styles.backgroundImage;
            var match = this.imgUrl.match(/url\([\'\"]?([^\'\"]+)[\'\"]?\)/);
            this.imgUrl = match && typeof match[1] != 'undefined'
                ? match[1]
                : false;
        }

        let dataSvg = this.object.getAttribute('data-svg');
        if (dataSvg) {
            this.imgUrl = dataSvg;
        } 

                if (!this.imgUrl) {
            var object = this.object;
            window.requestAnimationFrame(function(){
                svgToInline.load(object);
            });
        }
    },

    load: function(object) {
        this.object = object;
        this.setUrl();
        this._load();
    },

    _load: function(){
        var self = this,
            object = this.object,
            url = this.imgUrl,
            svg = '',
            key;

        if (url) {
            object.classList.add("svg-inited");

            if (!(key = this.find(url))) {

                self.loaded.push({
                    url: url,
                    svg: svg,
                    objects: [object]
                });

                key = self.loaded.length - 1;

                this.request(self.imgUrl, function(data) {
                    let div = document.createElement('div');
                    div.innerHTML = data;

                    svg = div.getElementsByTagName('svg')[0];

                    svg.removeAttribute('xmlns:a');
                    self.loaded[key].svg = svg;

                    for(var i in self.loaded[key].objects) {
                        self.replace(self.loaded[key].objects[i], svg);
                    }

                });
            } else {
                if (this.isLoaded(key)) {
                    self.replace(object, this.loaded[key].svg);
                } else {
                    this.loaded[key].objects.push(object);
                }

            }
        }

    },

    isLoaded: function(key){
        return this.loaded[key].svg != '';
    },

    replace: function(object, svg) {
        var imgID = object.getAttribute('id');
        var imgClass = object.getAttribute('class');

        if(imgID !== null) {
            svg.id = imgID;
        }
        if(imgClass !== null) {
            imgClass.split(" ").forEach(function(item, i){
                svg.classList.add(item);
            });
        }

                svg.classList.add('replaced-svg');

                object.parentNode.replaceChild(svg.cloneNode(true), object);


                    },

    find: function(url){
        for(var key in this.loaded) {
            if (this.loaded[key].url == url) {
                return key;
            }
        }

        return false;
    },

};
